var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgExclamation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "50 0 630 580",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m350 54.445c-59.82 0-117.19 23.762-159.49 66.062-42.301 42.301-66.062 99.672-66.062 159.49s23.762 117.19 66.062 159.49c42.301 42.301 99.672 66.062 159.49 66.062s117.19-23.762 159.49-66.062c42.301-42.301 66.062-99.672 66.062-159.49-0.042969-59.809-23.82-117.15-66.109-159.45-42.293-42.289-99.637-66.066-159.45-66.109zm15.398 328.22c-4.0352 4.1758-9.5898 6.5312-15.398 6.5312-2.9023-0.003907-5.7695-0.64062-8.3984-1.8672-2.6211-1.0703-5.0039-2.6602-7-4.6641-4.0977-4.0781-6.3945-9.6211-6.3789-15.402 0.015625-5.7734 2.3047-11.305 6.3789-15.398 2.0391-1.957 4.4062-3.5391 7-4.668 3.9883-1.6367 8.3672-2.0664 12.598-1.2344 4.2305 0.82812 8.125 2.8789 11.199 5.9023 2.0078 2 3.5938 4.3789 4.668 7 1.1758 2.6406 1.7617 5.5078 1.7109 8.3984 0.015625 5.7812-2.2812 11.324-6.3789 15.402zm6.3789-102.67c0 7.7812-4.1484 14.969-10.887 18.859s-15.043 3.8906-21.781 0-10.887-11.078-10.887-18.859v-87.266c-0.054687-5.8125 2.2148-11.402 6.3047-15.531s9.6602-6.4492 15.473-6.4492 11.383 2.3203 15.473 6.4492 6.3594 9.7188 6.3047 15.531z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgExclamation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exclamation.a5dbacd04c4e413768efe7a9715f9e50.svg";